import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../layout/css/style.css";

const Footer = () => {
  const location = useLocation();

  // Hide call button on Punjab page
  const hideCallButton =
    location.pathname.includes("hearing-aids-centre-punjab");

  useEffect(() => {
    // WhatsApp widget
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://d2jyl60qlhb39o.cloudfront.net/integration-plugin.js";
    script.id = "wa-widget";
    script.setAttribute("widget-id", "aaa8k8");
    document.body.appendChild(script);

    // DataLayer script
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.addEventListener("DOMContentLoaded", function () {
        var form = document.getElementById("kyc_form");
        if (form) {
          form.addEventListener("submit", function () {
            var emailValue = document.getElementById("kyc_email")?.value || '';
            var phoneValue = document.getElementById("kyc_mobile")?.value || '';

            if (!phoneValue.startsWith('+91')) {
              phoneValue = phoneValue.replace(/^0+/, '');
              phoneValue = '+91' + phoneValue;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'form_submitted',
              enhanced_conversion_data: {
                email: emailValue,
                phone: phoneValue
              }
            });
          });
        }
      });
    `;
    document.body.appendChild(inlineScript);

    return () => {
      document.body.removeChild(script);
      document.body.removeChild(inlineScript);
    };
  }, []);

  return (
    <>
      {/* Floating Call Button (hidden on Punjab page) */}
      {!hideCallButton && (
        <div className="floating_btn md:hidden blink">
          <a aria-label="Call us — Phone" href="tel:+919015401540">
            <div className="contact_icon1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                <path d="M14.05 2a9 9 0 0 1 8 7.94" />
                <path d="M14.05 6A5 5 0 0 1 18 10" />
              </svg>
            </div>
          </a>
        </div>
      )}

      {/* Footer */}
      <footer>
        &copy; {new Date().getFullYear()} SFL Hearing Solutions. All Rights Reserved.
      </footer>
    </>
  );
};

export default Footer;
